export default {
	"helpers.OnlyTheBeginningIsLeft": "距開始僅剩",
	"helpers.OnlyTheEndRemains": "距結束僅剩",
	"helpers.ThePurchaseQuantityCannotBe0": "購買數量不能為0",
	"helpers.prompt": "提示",
	"helpers.UntieTheBindingForTheTimeBeing": "暫不解綁",
	"helpers.UnbindTheAccount": "解綁帳號",
	"helpers.SorryThePriceHasChanged": "抱歉，價格已發生變化！",
	"helpers.SorryTheVerificationFailed": "抱歉，驗證未通過！",
	"helpers.YouHaveAnActivatedItem": "您存在已啟動商品",
	"helpers.YouHaveSubscribedToTheItem": "您已訂閱該商品",
	"helpers.PurchasesAreNotCurrentlyAvailableForThisItem": "該商品暫不支持購買"
}